export default __webpack_public_path__ + "static/media/bigmidia_sm.ae3242c8.webp";